import Home from '@/components/frame/Home'

const home = {
  isShow: false,
  index: 7,
  path: '/educationalTraining',
  component: Home,
  redirect: '/educationalTraining/index',
  name: 'educationalTraining',
  isHead: true,
  meta: {
    title: '教育培训',
    icon: 'el-icon-notebook-2'
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/educationalTraining/index'),
      name: 'EducationalTraining',
      meta: { title: '教育培训', close: false }
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/educationalTraining.js